import { ExtendedListChildComponentProps } from "@/components/core/InfiniteScrollList/VirtualizedList";
import { AvatarWithTextSkeleton } from "@/components/core/skeletons/AvatarWithTextSkeleton";
import { SkeletonTextGroup } from "@/components/core/skeletons/SkeletonTextGroup";

type OrderListCardSkeletonProps = ExtendedListChildComponentProps & {
  withAvatar?: boolean;
}

export function OrderListCardSkeleton({ style, ref, withAvatar = true }: OrderListCardSkeletonProps) {
  return (
    <div style={style} className="px-4">
      <div
        className="rounded-none border-0 border-b shadow-none p-0 pb-4"
        ref={ref}
      >
        <div className="flex items-start justify-between">
          <AvatarWithTextSkeleton
            withAvatar={withAvatar}
            textLines={[
              { size: "base", width: "lg" },
              { size: "sm", width: "md" },
              { size: "sm", width: "xl" },
            ]}
          />

          <SkeletonTextGroup
            lines={[
              { size: "base", width: "sm" },
              { size: "sm", width: "xs" },
              { size: "sm", width: "xs" },
              { size: "sm", width: "xs" },
            ]}
            className="text-right flex flex-col items-end"
            spacing="sm"
          />
        </div>
      </div>
    </div>
  );
} 